"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next";

const HIGHLIGHT_ORANGE = "#E2622F";

const OmniScorecardSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const raw = t("omniScorecard.stats", { returnObjects: true });
  const stats = Array.isArray(raw) ? raw : [];

  // "47 → 7 days" ya "47 ← 7 أيام" ko arrow par split karke bold icon lagata hai
  const renderValue = (value) => {
    const parts = String(value).split(/\s*[→←]\s*/);
    if (parts.length !== 2) return value;

    return (
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: { xs: 0.8, sm: 1 },
        }}
      >
        <span>{parts[0]}</span>
        <ArrowForwardIcon
          sx={{
            fontSize: { xs: 18, sm: 20, md: 22 },
            color: "#FFFFFF",
            // bold look dene ke liye stroke
            stroke: "#FFFFFF",
            strokeWidth: 1.5,
            transform: isArabic ? "rotate(180deg)" : "none",
          }}
        />
        <span>{parts[1]}</span>
      </Box>
    );
  };

  const cardBase = {
    borderRadius: "14px",
    px: { xs: 2.5, md: 3 },
    py: { xs: 2.5, md: 3 },
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 0.75,
    textAlign: isArabic ? "right" : "left",
  };

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 6, sm: 8, md: 10 },
        backgroundColor: "#14122B",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="md">
        {/* Header */}
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 5 } }}>
          <Typography
            sx={{
              fontSize: { xs: "10px", sm: "11px" },
              fontWeight: 600,
              color: "#FFB48C",
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              fontFamily: "var(--font-outfit)",
              mb: { xs: 1.5, sm: 2 },
            }}
          >
            {t("omniScorecard.label")}
          </Typography>

          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "24px", sm: "30px", md: "34px", lg: "38px" },
              fontWeight: 700,
              lineHeight: 1.25,
              color: "#FFFFFF",
              fontFamily: "var(--font-plusjakarta)",
            }}
          >
            {t("omniScorecard.heading")}
          </Typography>
        </Box>

        {/* Stats grid */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            },
            gap: { xs: 2, md: 2.5 },
          }}
        >
          {stats.map((stat, index) => {
            const isHighlight = index === stats.length - 1;

            return (
              <Box
                key={index}
                sx={{
                  ...cardBase,
                  backgroundColor: isHighlight ? HIGHLIGHT_ORANGE : "#221F3A",
                  border: isHighlight
                    ? `1px solid ${HIGHLIGHT_ORANGE}`
                    : "1px solid rgba(255,255,255,0.08)",
                  gridColumn: {
                    xs: "auto",
                    sm: isHighlight ? "1 / -1" : "auto",
                    md: isHighlight ? "span 2" : "auto",
                  },
                }}
              >
                <Typography
                  component="div"
                  sx={{
                    fontSize: {
                      xs: "24px",
                      sm: "26px",
                      md: isHighlight ? "26px" : "30px",
                    },
                    fontWeight: 700,
                    lineHeight: 1.2,
                    color: "#FFFFFF",
                    fontFamily: "var(--font-plusjakarta)",
                  }}
                >
                  {renderValue(stat.value)}
                </Typography>

                {stat.label && (
                  <Typography
                    sx={{
                      fontSize: { xs: "11px", md: "12px" },
                      color: "rgba(255,255,255,0.7)",
                      lineHeight: 1.5,
                      fontWeight: 400,
                      fontFamily: "var(--font-outfit)",
                    }}
                  >
                    {stat.label}
                  </Typography>
                )}
              </Box>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};

export default OmniScorecardSection;